var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      directives: [
        { name: "short-click", rawName: "v-short-click" },
        { name: "long-touch", rawName: "v-long-touch" },
      ],
      staticClass: "task",
      class: { dragging: _vm.isDragging },
      style: _vm.style,
      attrs: { href: "javascript:void(0)", draggable: "false" },
      on: {
        contextmenu: function ($event) {
          $event.preventDefault()
        },
        mousedown: function ($event) {
          return _vm.onMouseDown($event)
        },
        "short-click": function ($event) {
          return _vm.open()
        },
        "long-touch": function ($event) {
          return _vm.onLongTouch($event)
        },
      },
    },
    [
      _vm.hasUnread ? _c("div", { staticClass: "notification-dot" }) : _vm._e(),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { staticClass: "task-text", attrs: { xs: "6", lg: "9" } },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    style: { maxWidth: "40px", float: "left", height: "100%;" },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          mousedown: function ($event) {
                            $event.stopPropagation()
                          },
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.completeTask()
                          },
                        },
                      },
                      [
                        _vm.showCompleteButton
                          ? _c("w-fa", {
                              staticClass: "bttComplete",
                              attrs: {
                                size: "2x",
                                icon: ["far", "check-circle"],
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    !_vm.showCompleteButton
                      ? _c("w-fa", {
                          staticClass: "bttComplete finished",
                          attrs: { size: "2x", icon: ["far", "check-circle"] },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    style: {
                      float: "left",
                      width: "auto",
                      margin: "5px 0 0 10px",
                    },
                  },
                  [_vm._v(_vm._s(_vm.value.Text))]
                ),
              ]),
              _c(
                "div",
                { style: { marginLeft: "38px" } },
                [
                  _vm.users.length && _vm.fullAssignedUsers
                    ? _c(
                        "div",
                        { staticClass: "user" },
                        _vm._l(_vm.fullAssignedUsers, function (user, i) {
                          return _c("span", { key: i, staticClass: "user" }, [
                            _vm._v(
                              "@" +
                                _vm._s(user.Firstname) +
                                "." +
                                _vm._s(user.Lastname.charAt(0))
                            ),
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  (_vm.fullAssignedUsers.length && _vm.canEdit) ||
                  (_vm.fullAssignedUsers.length && _vm.value.DueDate)
                    ? _c("span", { staticClass: "bullet" }, [_vm._v("•")])
                    : _vm._e(),
                  _vm.value.DueDate
                    ? _c(
                        "div",
                        { staticClass: "timestamp" },
                        [
                          _c("w-fa", { attrs: { icon: ["far", "calendar"] } }),
                          _c("app-timeago", {
                            attrs: { datetime: _vm.value.DueDate },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.value.DueDate
                    ? _c("span", { staticClass: "bullet" }, [_vm._v("•")])
                    : _vm._e(),
                  _vm.canEdit
                    ? _c(
                        "w-link",
                        {
                          attrs: { draggable: "false" },
                          nativeOn: {
                            mousedown: function ($event) {
                              $event.stopPropagation()
                            },
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.editTask()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("edit-task")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "w-col",
            { attrs: { xs: "6", lg: "3" } },
            [
              _c(
                "w-row",
                { style: { justifyContent: "flex-end", minHeight: "64px" } },
                [
                  _c("w-spacer"),
                  _c("app-task-priority-chips", {
                    staticClass: "mrs",
                    attrs: { compact: "", value: _vm.value.Priority },
                    on: {
                      input: function ($event) {
                        return _vm.updatePriority($event)
                      },
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "task-status", class: _vm.statusClass },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$ct("models.TaskStatuses." + _vm.value.Status)
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }